import { MinDirective } from './minDirective';
import { NgModule } from '@angular/core';

@NgModule({
  imports: [],
  exports: [MinDirective],
  declarations: [MinDirective],
  providers: []
})
export class MinDirectiveModule {}
